import {Component, ElementRef, Input, ViewChild} from '@angular/core';

// https://stackoverflow.com/questions/42458346/need-to-insert-script-tag-in-angular-2

// NOTE: below code loads script async, so need some way to wait until it's loaded!

/**
 * <script-hack> is used to inject <script> tag to any component
 */
@Component({
    selector: 'script-hack',
    template: '<div #script style.display="none"><ng-content></ng-content></div>'
})
export class ScriptHackComponent {

    @Input()
    src: string;

    @Input()
    type: string;

    @ViewChild('script') script: ElementRef;

    convertToScript() {
        var element = this.script.nativeElement;
        var script = document.createElement('script');
        script.type = this.type ? this.type : 'text/javascript';
        if (this.src) {
            script.src = this.src;
        }
        if (element.innerHTML) {
            script.innerHTML = element.innerHTML;
        }
        var parent = element.parentElement;
        parent.parentElement.replaceChild(script, parent);
    }

    ngAfterViewInit() {
        this.convertToScript();
    }
}
